var map = {
	"./black-setting.svg": 7503,
	"./calendar.svg": 1550,
	"./down.svg": 4178,
	"./drill.svg": 8528,
	"./error.svg": 5810,
	"./exam.svg": 8079,
	"./fontSize.svg": 8600,
	"./home.svg": 7744,
	"./index.svg": 5066,
	"./learn.svg": 684,
	"./love.svg": 5754,
	"./message.svg": 7321,
	"./message2.svg": 4084,
	"./note.svg": 9273,
	"./peoples.svg": 3355,
	"./points.svg": 4865,
	"./poster.svg": 7267,
	"./privates.svg": 6974,
	"./right.svg": 3756,
	"./role.svg": 5973,
	"./scan.svg": 9233,
	"./school.svg": 2845,
	"./secondhand.svg": 3143,
	"./setting.svg": 5530,
	"./share.svg": 6901,
	"./shutdown.svg": 4487,
	"./submit.svg": 2188,
	"./teach.svg": 8037,
	"./thumb.svg": 1385,
	"./toTop.svg": 3702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;